import { useTranslation } from 'react-i18next';
import { useSnapshot } from 'valtio';
import { buildDateRangePickerEndTimeOptions, buildDateRangePickerStartTimeOptions } from 'basics/options/time.options';
import { commonFields } from 'modules/events/basics/constants/commonFormFields.constants';
import { PhyisicalEventStateType } from 'modules/events/basics/types/events.types';
import eventState from 'modules/events/states/events.states';

import { useYodaForm } from 'yoda-ui/yodaForm';

const useSessionInformation = () => {
  const { t } = useTranslation();

  const { formState, fieldsState, useWatchField, setValue } = useYodaForm();
  const dateRange = useWatchField(commonFields.sessionDateRange)?.value;
  const startTime = useWatchField(commonFields.sessionStartTime)?.value;
  const eventStateValue = useSnapshot(eventState) as PhyisicalEventStateType;
  const realStartTime = eventStateValue.createEvent.data?.session?.startTime;
  const realEndTime = eventStateValue.createEvent.data?.session?.endTime;

  const sessionFieldsState = {
    endTime: fieldsState[commonFields.sessionEndTime],
  };

  const sessionSetValue = (fieldName: string, fieldValue: unknown) => {
    const fieldMap: Record<string, string> = { endTime: commonFields.sessionEndTime };
    setValue(fieldMap[fieldName] || fieldName, fieldValue);
  };

  const startTimeOptions = buildDateRangePickerStartTimeOptions(
    { dateRange, startTime, realTime: realStartTime, setValue: sessionSetValue, fieldsState: sessionFieldsState },
  );

  const endTimeOptions = buildDateRangePickerEndTimeOptions(
    { dateRange, startTime, realTime: realEndTime, setValue: sessionSetValue, fieldsState: sessionFieldsState },
  );

  return {
    t,
    formState,
    fieldsState,
    startTimeOptions,
    endTimeOptions,
  };
};

export default useSessionInformation;
